<h2 mat-dialog-title>{{ 'map.auditTrailDialog.title' | t }}</h2>
<mat-dialog-content class="mat-typography">
  <div class="lprAuditHeader">
    <sn-searchbar class="lprAuditSearch" [placeholder]="'common.search' | t" (valueChange)="onSearchValueChange($event)"></sn-searchbar>
    <button mat-icon-button [matTooltip]="'common.refresh' | t" (click)="reload()">
      <sn-icon fontSet="fal" fontIcon="fa-redo-alt"></sn-icon>
    </button>
    <button mat-icon-button [matTooltip]="'map.auditTrailDialog.viewInAudit' | t" (click)="audit()">
      <sn-icon fontSet="fal" fontIcon="fa-external-link"></sn-icon>
    </button>
  </div>
  <ng-container *ngIf="isLoading">
    <mat-progress-spinner color="accent" diameter="32" mode="indeterminate"></mat-progress-spinner>
  </ng-container>
  <mat-table
    [dataSource]="dataSource"
    matSort
    matSortDisableClear
    [matSortActive]="sort"
    [matSortDirection]="sortDirection"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="createdAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header="timestamp">{{ 'common.createdAt' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let audit">
        <span class="fs-text-truncate">{{ audit.createdAt | fsFormatDate : 'medium' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="user">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.user' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let audit">
        <span class="fs-text-truncate">{{ audit.user?.name }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="object">
      <mat-header-cell *matHeaderCellDef>{{ 'common.object' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let audit">
        <sn-icon class="fs-mr-sm" [icon]="audit.object?.icon"></sn-icon>
        <span class="fs-text-truncate">{{ audit.object?.name }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef mat-sort-header="operation">{{ 'common.action' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let audit">
        <span class="fs-text-truncate">{{ audit.operation }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: columns"> </mat-row>
  </mat-table>
  <div *ngIf="!matTable?._data?.length && !isLoading">
    <sn-empty-state icon="cancel_presentation" [title]="'common.noResultsFound' | t"></sn-empty-state>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="lprGroupsFooter">
  <button mat-button color="warn" mat-dialog-close>{{ 'common.close' | t }}</button>
  <mat-paginator #paginator [pageSize]="pageSize" [length]="resultsLength"></mat-paginator>
</mat-dialog-actions>
